import React from 'react'

import { User } from 'model/User'
import { Avatar, Box, Card, CardContent, Typography } from '@mui/material'
import { Game } from 'model/Game'
import { DeckType } from 'model/DeckType'
import quizimg from '../../asset/quiz.png'

type Props = {
  user: User
  deckType?: DeckType
  media: {isPc: boolean}
  game: Game
}
export default function MatchingUser(props: Props) {

  const rateDiff = props.user.uuid === props.game.host.uuid
    ? props.game.host.rate_diff
    : props.game.guest.rate_diff

  function getDeckTypeName(): string {
    if (!props.deckType?.main_theme) return '???'
    if (props.deckType.main_theme.name === 'その他') {
      return props.deckType.note!
    }
    const mainThemeName = props.deckType.main_theme.name
    const subThemeName = props.deckType.sub_theme?.name
    let name = mainThemeName
    if (subThemeName) name += ` + ${subThemeName}`
    return name
  }

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Box
        display='flex'
        flexDirection='row'
        alignItems='center'
        sx={{
          width: '100%',
          mb: props.media.isPc ? 1 : 0.5,
          textOverflow: 'ellipsis',
        }}
      >
        <Avatar
          src={props.deckType?.thumbnail_url ?? quizimg}
        />
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ml: 0.5}}
        >
          {getDeckTypeName()}
        </Typography>
      </Box>
      <Card
        variant='outlined'
        sx={{
          width: props.media.isPc ? 160 : 140,
          borderColor: props.game.host.uuid === props.user.uuid ? 'info.light' : ''
        }}>
        <CardContent sx={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}>
          <Avatar
            src={props.user.profile_image_url}
            variant='rounded'
            sx={{
              width: props.media.isPc ? 100 : 80,
              height: props.media.isPc ? 100 : 80,
              mb: props.media.isPc ? 2 : 1
            }}
          />
          <Typography variant={props.media.isPc ? 'body1' : 'body2'} textAlign='center'>{ props.user.name }</Typography>
          <Typography variant={props.media.isPc ? 'body1' : 'body2'} textAlign='center'>{props.user.rate}</Typography>
          { rateDiff &&
            <Typography variant={props.media.isPc ? 'body1' : 'body2'} textAlign='center' color={rateDiff > 0 ? 'primary' : 'error'}>
              {(rateDiff > 0 ? '+' : '') + rateDiff}
            </Typography>
          }
        </CardContent>
      </Card>
    </Box>
  )
}